
import {Component, EventEmitter,OnChanges, OnInit,Input,Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseService } from '../../services/base.service';
import { CommonService } from '../../../shared/services/common.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ara-import-error',
  templateUrl: './import-error.component.html',
  styleUrls: ['./import-error.component.css']
})
export class ImportErrorComponent implements OnInit {
    @Input() ImportErrorList: any;
 
    ImportErrorData:any;
  constructor(private translate: TranslateService, private baseService: BaseService,private commonservice : CommonService) {
   
  }

  ngOnInit() 
  {
    this.ImportErrorData = this.ImportErrorList;
  }

}